<div 
  class="loading-container"
  [class.fullscreen]="fullscreen"
  [class.with-background]="background"
  [class.with-backdrop-blur]="backdropBlur"
  [style.--spinner-scale]="scale">
  <div class="loading-content">
    <app-progress></app-progress>
    @if (message) {
      <p class="loading-message">{{ message }}</p>
    }
  </div>
</div>
